/**
 * Normalize explicit pax type from API / DB / UI (internalPaxType, paxType, etc.).
 * @param {unknown} raw
 * @returns {'ADULT'|'CHILD'|'INFANT'|undefined}
 */
export function normalizeExplicitPaxType(raw) {
  if (raw == null || raw === "") return undefined;
  const s = String(raw).trim().toUpperCase();
  if (s === "ADULT" || s === "ADT" || s === "AD") return "ADULT";
  if (s === "CHILD" || s === "CHD" || s === "CHILDREN") return "CHILD";
  if (s === "INFANT" || s === "INF" || s === "INFANTS" || s === "INFT") return "INFANT";
  return undefined;
}

/**
 * Canonical pax type for a room-array slot. This is the single source of truth for LDS
 * (must match pricing loops in get_order_lds_payload).
 *
 * @param {'adults'|'kids'|'infants'} slot
 * @returns {'ADULT'|'CHILD'|'INFANT'}
 */
export function expectedPaxTypeForSlot(slot) {
  if (slot === "adults") return "ADULT";
  if (slot === "kids") return "CHILD";
  if (slot === "infants") return "INFANT";
  return "ADULT";
}

/**
 * Resolve paxType for LDS: **room slot only**. Declared internalPaxType / paxType on the object
 * must not override slot (prevents XML vs fare mismatch). Use {@link findPassengerSlotTypeMismatches}
 * to detect bad data before save.
 *
 * @param {Object} opts
 * @param {'adults'|'kids'|'infants'} opts.slot
 * @param {string} [opts.explicitPaxType] ignored for LDS (kept for call-site compatibility)
 * @returns {'ADULT'|'CHILD'|'INFANT'}
 */
export function derivePaxTypeFromAgeOrSelection({ slot, explicitPaxType: _ignored }) {
  return expectedPaxTypeForSlot(slot);
}
